export default "__VITE_ASSET__BBbI8uF1__"